import React from "react";
import { Box, Typography } from "@mui/material";

export default function BankingPage() {
  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        Banking
      </Typography>
      <Typography>
        Coming soon: Connect bank feeds, import transactions, reconcile.
      </Typography>
    </Box>
  );
}
